module.exports = __webpack_public_path__ + "assets/certificate_pdf/Microsys Solution Certified Specialist – Linux, Configuring_1E8CA66A.7c14d670.pdf";